import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  desiredAddons: [],
  desiredPlan: null
}

const quickPurchaseSlice = createSlice({
  name: 'quickPurchase',
  initialState,
  reducers: {
    resetQuickPurchaseInfo: () => initialState,
    setAddons: (state, action) => {
      state.desiredAddons = action.payload
    }
  }
})

export const {
  reducer,
  actions: {
    resetQuickPurchaseInfo,
    setAddons
  }
} = quickPurchaseSlice
